import React from "react";
import { TextContent, Faq } from "@project/shared";
import styled from "styled-components";
import Head from "next/head";
import Link from "next/link";

const Wrapper = styled.div`
  padding: 24px 15.28%;
  @media (max-width: 1375px) {
    padding: 24px 120px;
  }
  @media (max-width: 1075px) {
    padding: 24px 80px;
  }
  @media (max-width: 980px) {
    padding: 24px 50px;
  }
  @media (max-width: 920px) {
    padding: 24px 26px;
  }
  @media (max-width: 768px) {
    padding: 24px 0px;
  }
`;

const faq1 = {
  title: "side bizz（サイドビズ）とは？",
  faqs: [
    {
      question: "side bizz（サイドビズ）とは何ですか？",
      answer:
        "営業系のお仕事が探せる情報サイトです。営業職の副業（リファラル営業）、販売代理店やフルコミッションの仕事、業務委託の仕事などがたくさん掲載されているので、独立起業を目指す人やフリーランス、法人の新規商材を探すのにもオススメです。",
    },
    {
      question: "利用料金はかかりますか？",
      answer: "side bizzの利用料金は0円（無料）です。",
    },
    {
      question: "side bizzの使い方を教えてください。",
      answer:
        "side bizzは会員登録した人だけが利用できます。まずはご希望の検索条件で絞り込んで、求人情報をご覧ください。気になる求人情報があればエントリーしたり、掲載企業にメッセージを送信してください。",
    },
    {
      question: "side bizzで副業しても会社にバレませんか？",
      answer:
        "side bizzに登録された情報が無断で第三者に開示されることはございません。",
    },
    {
      question: "side bizzの新着はいつ更新されますか？",
      answer:
        "新着日は無いので、新着情報は毎日更新される可能性があります。新着情報はできれば毎日チェックしてください。",
    },
  ],
};

const faq2 = {
  title: "サイトの使い方について",
  faqs: [
    {
      question: "副業したい場合にはどうすればいいですか？",
      answer:
        "副業にはリファラル営業がオススメです。募集区分「リファラル営業」で絞り込んだ求人情報をご覧ください。",
    },
    {
      question: "高収入の仕事はどうやって探せばいいですか？",
      answer:
        "高収入の仕事は販売代理店やフルコミッションのお仕事なので、募集区分「エージェント」で絞り込んだ求人情報をご覧ください。",
    },
    {
      question: "スカウトとは何ですか？",
      answer:
        "あなたが入力したプロフィールを見た掲載企業からのオファーになります。もしその仕事にご興味があればエントリーをしてください。",
    },
    {
      question: "スカウトはどうすれば増えますか？",
      answer:
        "スカウトはプロフィール情報を充実させることで件数が増えていきます。掲載企業がスカウトしたくなるような魅力的なプロフィールを作成しましょう。",
    },
    {
      question: "スカウトは停止できますか？",
      answer:
        "プロフィール設定にある「お仕事受付」を「受付停止」に変更してください。",
    },
    {
      question: "「興味がある」ボタンはどんな時に使えばいいですか？",
      answer:
        "求人サイトのエントリーと同じ役割になるので、少しでも気になったお仕事があれば気軽にエントリー（無料）してみてください。",
    },
    {
      question: "「メッセージ」はどんな時に使えばいいですか？",
      answer:
        "メッセージは、報酬条件やお仕事内容などを掲載企業に質問できる機能です。疑問点があれば気軽に聞いてみましょう。",
    },
    {
      question: "「案件紹介フォーム」はどこにありますか？",
      answer:
        "案件紹介フォームは求人詳細のページ内にありますが、リファラル営業の求人にしか実装されていません。また。固定報酬が設定されている求人では、稼働開始後から案件紹介フォームが出てきます。",
    },
    {
      question: "掲載企業との契約手続きはどうすればいいですか？",
      answer:
        "リファラル営業の場合には契約手続きが不要です。エージェントの求人情報では、掲載企業との契約手続きが必要となります。",
    },
    {
      question: "退会方法について教えてください。",
      answer:
        "退会手続きは、マイページの「プロフィール設定」からお願いします。ただし、一度退会手続きをされると、今までご利用された情報が全て削除されます。再度ご利用いただく際に情報を引き継ぐことはできかねますので、予めご了承ください。",
    },
  ],
};

const faq3 = {
  title: "募集区分について",
  faqs: [
    {
      question: "リファラルとは何ですか？",
      answer:
        "リファラルは「紹介営業」と呼ばれる営業スタイルです。side bizzはプラットフォームをご用意しておりますので、掲載企業との契約（業務委託契約など）は不要です。",
    },
    {
      question: "エージェントとは何ですか？",
      answer:
        "エージェントの区分は、掲載企業と直接契約することが前提の求人となります。自由に条件交渉してください。",
    },
  ],
};

const faq4 = {
  title: "リファラル営業の報酬体系について",
  faqs: [
    {
      question: "リファラル営業の報酬種類について教えてください。",
      answer: "報酬には「固定報酬」と「成果報酬」の2種類があります。",
    },
    {
      question: "リファラル営業の固定報酬額はいくらですか？",
      answer:
        "固定報酬は一律2万円/30日間（税抜）です。180日分までまとめて受け取れるので、その場合には12万円/180日間（税抜）になります。",
    },
    {
      question: "リファラル営業の固定報酬はどうすれば貰えますか？",
      answer:
        "固定報酬が貰えるお仕事は限られていますが、依頼内容に同意した段階で2万円以上（税抜）が支払われます。",
    },
    {
      question: "リファラル営業の成果報酬とは何ですか？",
      answer:
        "成果報酬とは所定の条件（※求人情報の「報酬条件」に記載）に達した場合に支払われる報酬です。金額は数万円が多いですが、固定報酬と合わせると10万円前後（税抜）になるケースが多いです。",
    },
    {
      question: "リファラル営業の固定報酬は辞退しても良いですか？",
      answer:
        "リファラル営業の固定報酬を自分から辞退するのは構いませんが、「固定報酬に同意」した後に辞退することはできません。",
    },
    {
      question:
        "「固定報酬あり」の求人なのに、成果報酬のみで条件提示されました。",
      answer:
        "それは契約違反の行為です。その掲載企業名や内容をside bizz運営事務局にお教えください。",
    },
    {
      question: "リファラル営業の報酬はどうやって受け取ればいいですか？",
      answer:
        "報酬の支払いは、ウェブエックス株式会社（side bizz運営元）からside bizz会員の指定銀行口座にお振込みいたします。なお、振込1回につき一律300円の振込手数料が報酬額から差し引かれます。",
    },
    {
      question: "リファラル営業の報酬はいつ支払われますか？",
      answer: function (): React.ReactElement {
        return (
          <>
            リファラル営業の報酬は、所定の定義の翌々月末を期日にお支払いいたします。詳しくは
            <Link href="/terms">会員規約</Link>
            をご覧ください。
          </>
        );
      },
    },
    {
      question: "リファラル営業の報酬は中抜きされないですか？",
      answer:
        "報酬が中抜きされることはありません。side bizzは企業からの掲載料金などで運営しておりますのでご安心ください。",
    },
  ],
};

const faq5 = {
  title: "リファラル営業の注意点",
  faqs: [
    {
      question: "どのような基準で仕事（リファラル営業）を選べば良いですか？",
      answer:
        "リファラル営業は自分のお仕事に関連するものや、人脈・販路にご案内しやすいものにエントリーしてください。",
    },
    {
      question: "リファラル営業を実践する上での注意点を教えてください。",
      answer:
        "相手に必ず「●●株式会社（掲載企業）から提案がくること」の承諾を得ることです。また、掲載企業にお知り合いを紹介する場合は必ずside bizzを経由するようにしてください。side bizzを経由しない案件紹介には報酬が支払われません。",
    },
    {
      question: "見込み案件の紹介はどうすればいいですか？",
      answer:
        "掲載企業に知人・友人などを紹介する時は「案件紹介フォーム」をご利用ください。この機能を経由した紹介だけが成果報酬の対象になります。",
    },
    {
      question: "30日の稼働期間が終了した場合、どうすれば良いですか？",
      answer:
        "固定報酬が支払われた場合、30日の稼働期間があります。その期間が終了した時には、掲載企業と打ち合わせして、営業活動をフィードバックしてください。",
    },
    {
      question:
        "掲載企業の要望件数を満たせませんでした。どうすれば良いですか？",
      answer:
        "掲載企業の要望件数を満たせなかった場合、掲載企業と相談してください。一度掲載企業と打ち合わせすることをオススメします。",
    },
  ],
};

const allFaqs = [faq1, faq2, faq3, faq4, faq5];

const Faqs = () => {
  return (
    <Wrapper>
      <Head>
        <title>よくある質問 | side bizz</title>
      </Head>
      <TextContent title="よくある質問" />
      {allFaqs.map((faq, index) => {
        return <Faq faq={faq} key={index} />;
      })}
    </Wrapper>
  );
};

export default Faqs;
